import { render, staticRenderFns } from "./TaxNumberPdf.vue?vue&type=template&id=56fd7118&"
import script from "./TaxNumberPdf.vue?vue&type=script&lang=js&"
export * from "./TaxNumberPdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports